module.exports = __webpack_public_path__ + "img/1989_L.52054f51.png";